"use strict";
//@ts-nocheck
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateScanCount = exports.removeDriverDeviceToken = exports.registerDriverDeviceToken = exports.fetchDriverInfo = exports.fetchDrivers = exports.fetchOrganization = exports.fetchOrganizations = exports.updateMePhoto = exports.getGeofenceRadius = exports.updateLastActivity = exports.getLatestAppVersion = exports.updateMe = exports.fetchUser = exports.fetchMe = void 0;
var snakecase_keys_1 = __importDefault(require("snakecase-keys"));
var config_1 = __importDefault(require("../../config"));
var base_1 = require("./base");
var fetchMe = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.user, "me/"), token, 'GET')];
}); }); };
exports.fetchMe = fetchMe;
var fetchUser = function (token, username, manifestLinkId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.user).concat(username, "/").concat(manifestLinkId ? "?s=".concat(manifestLinkId) : ''), token, 'GET')];
    });
}); };
exports.fetchUser = fetchUser;
var updateMe = function (token, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.user, "me/"), token, 'PATCH', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.updateMe = updateMe;
var getLatestAppVersion = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApi)("".concat(config_1.default.urls.user, "get-latest-app-version/"), 'GET')];
}); }); };
exports.getLatestAppVersion = getLatestAppVersion;
var updateLastActivity = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.user, "update-last-activity/"), token, 'POST')];
}); }); };
exports.updateLastActivity = updateLastActivity;
var getGeofenceRadius = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApi)("".concat(config_1.default.urls.user, "get-geofence-radius/"), 'GET')];
}); }); };
exports.getGeofenceRadius = getGeofenceRadius;
var updateMePhoto = function (token, photo) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = new FormData();
        // @ts-ignore
        data.append('photo', {
            uri: photo.photo.fullSize,
            name: photo.name,
            type: photo.type,
        });
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.user, "me/"), token, 'PATCH', { 'Content-Type': 'multipart/form-data' }, data)];
    });
}); };
exports.updateMePhoto = updateMePhoto;
var fetchOrganizations = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)(config_1.default.urls.organizations, token)];
}); }); };
exports.fetchOrganizations = fetchOrganizations;
var fetchOrganization = function (token, id) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.organizations).concat(id, "/"), token)];
}); }); };
exports.fetchOrganization = fetchOrganization;
var fetchDrivers = function (token, url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(url ? "".concat(url) : "".concat(config_1.default.urls.user, "drivers/?offset=0")), token, 'GET')];
    });
}); };
exports.fetchDrivers = fetchDrivers;
var fetchDriverInfo = function (token, id) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.user, "driver-info/?id=").concat(id), token, 'GET')];
}); }); };
exports.fetchDriverInfo = fetchDriverInfo;
var registerDriverDeviceToken = function (token, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.user, "me/device-tokens/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)), false)];
    });
}); };
exports.registerDriverDeviceToken = registerDriverDeviceToken;
var removeDriverDeviceToken = function (token, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.user, "me/device-tokens/"), token, 'DELETE', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)), false)];
    });
}); };
exports.removeDriverDeviceToken = removeDriverDeviceToken;
var updateScanCount = function (token, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.user, "scan-counts/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)), false)];
    });
}); };
exports.updateScanCount = updateScanCount;
